import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Spinner, Alert, ModalFooter, Form, Label, Row, Col, Input, } from 'reactstrap';
// import { deleteResidue } from '../../../../slices/thunks';
// import { setRequireCloseModal } from '../../../../slices/residue/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { finalDestinationCertificationGuide, finalDestinationReceptionGuide, uploadFoldersFile } from '../../../../../slices/thunks';
import { createSelector } from 'reselect';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import useFileType from '../../../../../Components/Hooks/useFileTypeHooks';

const ConfirmCertificationGuidesModal = ({ guidesReception, isOpen, folders, establishmentId, handlerToggleModal }) => {
	const dispatch = useDispatch();

	const selectorGuide = createSelector(
		state => state.Guides,
		guide => ({
			isCertifying: guide.isCertifying,
			isCertified: guide.isCertified,
			isCertifiedError: guide.isCertifiedError,
			requireCloseModal: guide.requireCloseModal
		})
	);

	const { isCertifying, isCertified, isCertifiedError, requireCloseModal } = useSelector(selectorGuide);
	const { file_type } = useFileType('CDF');

	// Validation
	const uploadDocument = async (file, folderPaths, fileTypeId, establishment) => {
		const paths = (folderPaths || []).filter(
			path => typeof path === 'string' && path.trim().length > 0
		);
		if (!paths.length) {
			throw new Error(
				'No hay rutas de carpeta válidas para las guías seleccionadas. Verifique que las guías tengan folio o número de guía.'
			);
		}
		if (!fileTypeId) {
			throw new Error('No se encontró el tipo de archivo CDF.');
		}
		if (!establishment) {
			throw new Error('Las guías seleccionadas deben pertenecer a un mismo establecimiento.');
		}

		const formData = new FormData();
		formData.append('file', file);
		formData.append('file_type_id', fileTypeId);
		formData.append('establishment_id', establishment);
		paths.forEach(path => formData.append('folder_paths', path));

		try {
			const response = await dispatch(uploadFoldersFile(formData)).unwrap();
			if (response) {
				return response;
			} else {
				throw new Error('File upload failed');
			}
		} catch (error) {
			console.error('Error uploading file:', error);
			throw error;
		}
	};

	let document = null
	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: false,
		initialValues: {
			guides: guidesReception,
			certificate_document: '',
			// other_document: null
		},
		validationSchema: Yup.object({
			certificate_document: Yup.mixed()
				.required('El documento Certificado de Disposición Final es requerido')
				.test('documentFormat', 'Solo puede subir extensiones .pdf', value => {
					if (value) {
						const supportedFormats = ['pdf'];
						return supportedFormats.includes(value.name.split('.').pop());
					}
					return true;
				})
				.test('documentSize', 'El archivo no puede superar el tamaño máximo de 10MB', value => {
					if (value) {
						return value.size <= 10485760;
					}
					return true;
				})
		}),
		onSubmit: async (values) => {
			try {
				await uploadDocument(
					values.certificate_document,
					folders,
					file_type?._id,
					establishmentId
				);
				const dataGuide = {
					guides: guidesReception
				};
				dispatch(finalDestinationCertificationGuide(dataGuide));
			} catch (error) {
				toast.error(
					error?.message || 'Error al subir el certificado de disposición final.',
					{ autoClose: 5000 }
				);
			}
		},
	});


	const handleCancel = () => {
		validation.setFieldValue('certificate_document', '');
		handlerToggleModal();
	};

	function handlerOkModal() {
		validation.submitForm();
	}

	const handleFileCertificateChange = (event) => {
		const file = event.currentTarget.files[0];
		validation.setFieldValue("certificate_document", file);
	};

	const handleFileOtherChange = (event) => {
		const file = event.currentTarget.files[0];
		validation.setFieldValue("other_document", file);
	};

	return (

		<Modal
			isOpen={isOpen}
			toggle={() => handlerToggleModal()}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>

			<Form
				// className='tablelist-form'
				onSubmit={e => {
					e.preventDefault();
					validation.handleSubmit();
					return false;
				}}
			>
				<ModalHeader >Confirmar Certificación de Disposición Final</ModalHeader>
				<ModalBody className='modal-body'>
					<Row>
						<Col>
							<h5 className='mb-3'>
								Estás a punto de confirmar la certificacion de las guías seleccionados
							</h5>
						</Col>
					</Row>

					<Row className='g-3'>
						<Col lg={12}>
							<Label for="certificate_document">
								Certificado de Disposición Final
							</Label>
							<Input
								id="certificate_document"
								name="certificate_document"
								type="file"
								onChange={handleFileCertificateChange}
							/>
							{validation.errors.certificate_document && (
									<div className="invalid-feedback d-block">
										{validation.errors.certificate_document}
									</div>
								)}
						</Col>
					</Row>

					{/* <Row className='g-3'>
						<Col lg={12}>
							<Label for="other_document">
								Otro documento
							</Label>
							<Input
								id="other_document"
								name="other_document"
								type="file"
								onChange={handleFileOtherChange}
							/>
						</Col>
					</Row> */}

				</ModalBody>
				<ModalFooter>
					<div className='hstack gap-2 justify-content-end'>
						<Button type='button' onClick={() => handleCancel()} className='btn-danger btn-label'><i className="icon-x label-icon"></i> Cancelar</Button>
						<button
							className='btn btn-label btn-primary'
							onClick={() => handlerOkModal()}
							disabled={isCertifying}
						>
							{isCertifying ? (
								<i className='label-icon'><Spinner size='sm' /></i>
							) : <i className={`${Icons.check2} label-icon`}></i>}
							Confirmar
						</button>
					</div>
				</ModalFooter>
			</Form>

		</Modal>

		// <div>
		// 	<Modal
		// 		isOpen={isOpen}
		// 		toggle={() => handlerToggleModal()}
		// 		id='firstmodal'
		// 	>
		// 		<ModalHeader >Confirmar Certificacion</ModalHeader>
		// 		<ModalBody className='text-center p-3'>
		// 			{/* <lord-icon
		// 				src='https://cdn.lordicon.com/tdrtiskw.json'
		// 				trigger='loop'
		// 				colors='primary:#f06548,secondary:#405189'
		// 				style={{ width: '90px', height: '90px' }}
		// 			></lord-icon> */}
		// 			<div className='mt-2'>
		// 				<h5 className='mb-3'>
		// 					¡Atención! Estás a punto de confirmar la certificacion de las guías seleccionados
		// 				</h5>
		// 				<p className='text-muted mb-4'>
		// 					Si deseas realizar esta acción debes hacer click en
		// 					confirmar.
		// 				</p>
		// 				<div className='hstack gap-2 justify-content-center'>

		// 				</div>
		// 			</div>
		// 		</ModalBody>
		// 	</Modal>
		// </div>
	);
};

export default ConfirmCertificationGuidesModal;